import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Your existing service worker logic (with registration still commented out):
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        const isLocalhost = Boolean(
            window.location.hostname === 'localhost' ||
            window.location.hostname === '[::1]' ||
            window.location.hostname.match(
                /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/
            )
        );

        // const swPath = isLocalhost
        //     ? '/service-worker.js'
        //     : './service-worker.js';

        // navigator.serviceWorker.register(swPath)
        //     .then(registration => {
        //         console.log('✅ ServiceWorker registered with scope:', registration.scope);

        //         registration.onupdatefound = () => {
        //             const installing = registration.installing;
        //             if (installing) {
        //                 installing.onstatechange = () => {
        //                     if (installing.state === 'installed') {
        //                         if (navigator.serviceWorker.controller) {
        //                             console.log('🆕 New content is available; reloading...');
        //                             // window.location.reload(); // Force update
        //                         } else {
        //                             console.log('📦 Content cached for offline use.');
        //                         }
        //                     }
        //                 };
        //             }
        //         };
        //     })
        //     .catch(error => {
        //         console.error('❌ ServiceWorker registration failed:', error);
        //     });
    });
}
